<template>
    <a-config-provider>
        <div id="app">
            <router-view/>
        </div>
    </a-config-provider>
</template>

<script>
import { ConfigProvider } from 'ant-design-vue';

export default {
    name: 'App',
    components: {
        'a-config-provider': ConfigProvider,
    },
}
</script>
